import * as yup from 'yup';

export const feedbackValidationSchema = yup.object().shape({
  feedback: yup
    .string()
    .matches(/^(?:\s*\S+(?!\S)){20,500}\s*$/, `Please write at least 20 words `)
    .required('Your feedback is required'),
});
